import React from "react";
import { Link } from "react-router-dom";

export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6 text-foreground">
      <div className="w-full max-w-sm space-y-6 animate-in-up">
        <div>
          <div className="mb-3 flex items-center gap-2">
            <img src="/logo-amax.png" alt="amax" className="h-7 w-auto dark:brightness-0 dark:invert" />
            <span className="font-heading text-lg font-extrabold uppercase">RepairOps</span>
          </div>
          <h2 className="font-heading text-2xl font-bold uppercase tracking-tight">{title}</h2>
          {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
        </div>
        {children}
        <Link to="/login" className="block text-center text-xs text-muted-foreground hover:text-primary" data-testid="back-to-login">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}

export function Notice({ children, tone = "ok", ...props }) {
  const cls = tone === "ok" ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400" : "border-red-500/40 bg-red-500/10 text-red-600 dark:text-red-400";
  return <div className={`rounded-md border p-3 text-sm ${cls}`} {...props}>{children}</div>;
}
